import { useTranslation } from "react-i18next";
import { useState } from "react";
import { GetAllCompanyDto } from "@/types/api/api-types";
import { GeneralInfoModalCreatePickup } from "@/components/profile/generalInfoComponents/pickupLocations/generalInfoModalCreatePickup";
import { PickupEntityGroup } from "@/components/profile/generalInfoComponents/pickupLocations/pickupEntityGroup";
import { GeneralInfoModalPickup } from "@/components/profile/generalInfoComponents/pickupLocations/generalInfoModalPickup";

type GeneralInfoPickupProps = {
  company?: GetAllCompanyDto;
};

export const GeneralInfoPickup = ({ company }: GeneralInfoPickupProps) => {
  const { t } = useTranslation("boClients");
  const [editing, setEditing] = useState(0);

  const handleEdit = (editIndex: number) => {
    setEditing(editIndex);
  };

  const defaultPickupLocation = company?.pickUpLocations.find((el) => el.isDefault);

  const otherPickupLocations = company?.pickUpLocations.filter((el) => el.isDefault === false);

  const displayModal = () => {
    switch (editing) {
      case 1:
        return <GeneralInfoModalPickup closeModal={() => setEditing(0)} company={company!} />;
      case 2:
        return <GeneralInfoModalCreatePickup closeModal={() => setEditing(0)} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex w-full flex-1 flex-col items-center gap-6 lg:px-8">
      <div className="flex w-full flex-row justify-between gap-2 border-0 border-b border-gray-200 pb-5">
        <div className="items-left flex flex-col gap-2">
          <h2 className="text-lg font-semibold">{t("profileGeneralInfoPickup.title")}</h2>
          <p className="text-sm text-gray-600">{t("profileGeneralInfoPickup.subtitle")}</p>
        </div>
        <div className="flex flex-col gap-4 md:flex-row">
          <button
            onClick={() => handleEdit(2)}
            className="bg-brand700 hover:bg-brand600 h-fit rounded-lg border px-3 py-2 text-sm font-semibold text-white"
          >
            {t("profileGeneralInfoPickup.create")}
          </button>
          <button
            onClick={() => handleEdit(1)}
            className="h-fit rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200 hover:text-gray-800"
          >
            {t("profileGeneralInfoPickup.edit")}
          </button>
        </div>
      </div>
      <div className="flex w-[95%] flex-col gap-10">
        {defaultPickupLocation && (
          <div className="flex flex-col">
            <h3 className="text-base font-medium text-black">
              {t("profileGeneralInfoPickup.defaultLocationTitle")}
            </h3>
            <PickupEntityGroup {...defaultPickupLocation} />
          </div>
        )}
        {otherPickupLocations?.map((pickUpLocation, index) => (
          <div className="flex flex-col" key={index}>
            <h3 className="text-base font-medium text-black">
              {t("profileGeneralInfoPickup.additionalLocationTitle")}
            </h3>
            <PickupEntityGroup {...pickUpLocation} />
          </div>
        ))}
      </div>
      {displayModal()}
    </div>
  );
};
